import React, { createContext, useState, useContext } from "react";

const CountyContext = createContext();

export const CountyProvider = ({ defaultCounty = "All", children }) => {
  const [selectedCounty, setSelectedCounty] = useState(defaultCounty);
  const [counties, setCounties] = useState([]);

  return (
    <CountyContext.Provider
      value={{
        selectedCounty,
        setSelectedCounty,
        counties,
        setCounties,
      }}
    >
      {children}
    </CountyContext.Provider>
  );
};

export const useCounty = () => {
  const context = useContext(CountyContext);
  if (!context) {
    throw new Error("useCounty must be used within a CountyProvider");
  }
  return context;
};
